import { render, staticRenderFns } from "./Channel.vue?vue&type=template&id=263ad395&scoped=true&"
import script from "./Channel.vue?vue&type=script&lang=js&"
export * from "./Channel.vue?vue&type=script&lang=js&"
import style0 from "./Channel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Channel.vue?vue&type=style&index=1&id=263ad395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263ad395",
  null
  
)

export default component.exports